export default __webpack_public_path__ + "media/15c5b8604fef621b907f6e11d522d9165d0dc3bf266b431abe4defd09d70614e.svg";